import { Select } from "@cofano/cck";
import { VesselType } from "__generated__/enums";
import { SelectProps } from "@cofano/cck/Select/Select";
import { intl } from "LocaleWrapper";

const ShipVesselTypeSelect = ({ value, onChange, label, clearable }: Omit<SelectProps<VesselType, false>, "fetchOptions">) => {
	return (
		<Select
			disableSearch
			label={label}
			onChange={onChange}
			fetchOptions={Object.values(VesselType)}
			getOptionLabel={option => {
				if (option === VesselType.Barge) {
					return intl.formatMessage({ id: "BARGE" });
				} else {
					return intl.formatMessage({ id: "SEA_SHIP" });
				}
			}}
			clearable={clearable}
			value={value}
		/>
	);
};

export default ShipVesselTypeSelect;
